import { FCWithChildren } from 'common/types';
import { VerificationStatus } from 'features/Onboarding/modules/Verification/lib/steps/types';

import { Icon } from '../../../../Bento/atoms';
import { OBCardRow } from '../../../../Bento/components';
import { RowStatus } from '../../../../Onboarding/modules/Verification/pages/Home/components/VerificationRow';

interface HubStepProps {
  onClick: () => void;
  isDisabled: boolean;
  src: string;
  status: VerificationStatus;
}

const HubStep: FCWithChildren<HubStepProps> = ({
  children,
  isDisabled,
  onClick,
  src,
  status,
}) => {
  return (
    <OBCardRow
      isDisabled={isDisabled}
      onClick={isDisabled ? undefined : onClick}
    >
      <RowStatus src={src} status={status} />

      <OBCardRow.Body>{children}</OBCardRow.Body>

      {!isDisabled ? (
        <OBCardRow.Action>
          <Icon name="chevron-right" />
        </OBCardRow.Action>
      ) : null}
    </OBCardRow>
  );
};

export default HubStep;
